import { render, staticRenderFns } from "./modify-form.vue?vue&type=template&id=c188b3aa&scoped=true&"
import script from "./modify-form.vue?vue&type=script&lang=js&"
export * from "./modify-form.vue?vue&type=script&lang=js&"
import style0 from "./modify-form.vue?vue&type=style&index=0&id=c188b3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c188b3aa",
  null
  
)

export default component.exports